import { getColorValue } from '@shinetools/sunshine';
import styled from 'styled-components';

import chillImg from 'assets/brand/chill.png';
import Text from 'components/_core/Text';

export const ClientLoopImage = styled.img.attrs({
  alt: '',
  src: chillImg,
})`
  height: 144px;
  width: 144px;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: ${({ theme }) => theme.spacings.abs16}px;
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const Title = styled(Text).attrs({
  fontWeight: 'weight-500',
  size: 'lg',
  variant: 'primary',
})`
  display: block;
`;

export const SecondaryText = styled(Text)`
  display: block;
  margin-top: ${({ theme }) => theme.spacings.abs16}px;
  margin-bottom: ${({ theme }) => theme.spacings.abs4}px;
`;

export const FiltersContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: ${({ theme }) => theme.spacings.abs24}px;
`;

export const LeftFilter = styled.div<{
  isActive: boolean;
}>`
  height: 40px;
  background-color: ${({ isActive }): string =>
    isActive ? getColorValue('grey.400') : getColorValue('grey.200')};
  border-radius: ${({ theme }) => theme.borders.radius.base}px 0px 0px
    ${({ theme }) => theme.borders.radius.base}px;
  padding: 7px 12px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  color: ${({ isActive }): string =>
    isActive ? getColorValue('grey.800') : getColorValue('grey.600')};
  cursor: pointer;
  font-weight: 500;
`;

export const RightFilter = styled(LeftFilter)`
  border-radius: 0px ${({ theme }) => theme.borders.radius.base}px
    ${({ theme }) => theme.borders.radius.base}px 0px;
`;
